module.exports = __webpack_public_path__ + "img/monitorbox10.0678a56b.jpg";